import React from 'react';
import { calcNearestStep } from '../util';
import { formatPercent } from 'utils';

type ForecastReturnRowProps = {
  riskLevelDescriptions: any[];
  title: string;
  returnAndRisk: any;
  defaultRiskAndReturn: any;
};

enum forecastCateories {
  IN_A_VERY_GOOD_YEAR = 'In a very good year',
  IN_A_GOOD_YEAR = 'In a good year',
  ON_AVERAGE = 'On average',
  IN_A_BAD_YEAR = 'In a bad year',
  IN_A_VERY_BAD_YEAR = 'In a very bad year'
}

const ForecastReturnRow: React.FC<ForecastReturnRowProps> = ({
  riskLevelDescriptions,
  title,
  returnAndRisk,
  defaultRiskAndReturn
}) => {
  const calc = (risk: number, riskAndReturnData: any) => {
    if (
      !!riskAndReturnData[risk] &&
      !!riskAndReturnData[risk].return &&
      !!riskAndReturnData[risk].risk
    ) {
      if (title === forecastCateories.IN_A_VERY_GOOD_YEAR) {
        return calcNearestStep(
          (Number(riskAndReturnData[risk].return) +
            1.645 * Number(riskAndReturnData[risk].risk)) *
            100
        );
      }
      if (title === forecastCateories.IN_A_GOOD_YEAR) {
        return calcNearestStep(
          (Number(riskAndReturnData[risk].return) +
            0.675 * Number(riskAndReturnData[risk].risk)) *
            100
        );
      }
      if (title === forecastCateories.ON_AVERAGE) {
        return calcNearestStep(Number(riskAndReturnData[risk].return) * 100);
      }
      if (title === forecastCateories.IN_A_BAD_YEAR) {
        return calcNearestStep(
          (Number(riskAndReturnData[risk].return) +
            -0.675 * Number(riskAndReturnData[risk].risk)) *
            100
        );
      }
      if (title === forecastCateories.IN_A_VERY_BAD_YEAR) {
        return calcNearestStep(
          (Number(riskAndReturnData[risk].return) +
            -1.645 * Number(riskAndReturnData[risk].risk)) *
            100
        );
      }
    }
  };

  return (
    <div className="forecastReturnsConfigContainer">
      <div
        className="riskLevelInput"
        style={{
          width: `calc(100% / ${riskLevelDescriptions.length + 1})`,
          fontWeight: 'bold'
        }}
      >
        <div>{title}</div>
      </div>
      {riskLevelDescriptions.map((rld: any) => {
        return (
          <div
            key={`${rld.risk_type}`}
            className="riskLevelInput"
            style={{
              width: `calc(100% / ${riskLevelDescriptions.length + 1})`,
              border: '1px solid lightgray',
              backgroundColor:
                calc(rld.risk_level, returnAndRisk) ===
                calc(rld.risk_level, defaultRiskAndReturn)
                  ? 'rgb(238, 238, 238)'
                  : 'rgba(89, 137, 197, 0.4)'
            }}
          >
            <div>{`${formatPercent(calc(rld.risk_level, returnAndRisk))}`}</div>
          </div>
        );
      })}
    </div>
  );
};

export default ForecastReturnRow;
